import { render, staticRenderFns } from "./OutputLC.vue?vue&type=template&id=54ca6bc1&scoped=true&"
import script from "./OutputLC.vue?vue&type=script&lang=js&"
export * from "./OutputLC.vue?vue&type=script&lang=js&"
import style0 from "./OutputLC.vue?vue&type=style&index=0&id=54ca6bc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ca6bc1",
  null
  
)

export default component.exports